<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />

      <el-popconfirm
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon="el-icon-info"
        icon-color="red"
        title="确认离线导出么？"
        @confirm="rsyncExport('online')"
      >
        <el-button slot="reference" v-if="hasPermsExport"><i class="el-icon-upload2" />离线导出(线上)</el-button>
      </el-popconfirm>
      <button-link :to="`downloads`" v-if="hasPermsManageDownload"><i class="el-icon-download" />下载中心</button-link>
    </el-button-group>

    <el-row class="grid-content bg-el-row " v-for="item in orders" :key="item.id" v-loading="loading">
      <el-col :xl="24" :xs="24" :sm="24" :md="24" :lg="24">
        <div class="grid-content-col-title">
          <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
            <div>订单编号：{{ item.order_id }}[{{ item.order_type_text }}]</div>
          </el-col>
          <el-col :xl="6" :xs="6" :md="6" :lg="5" :sm="6">
            <div>
              审核状态：
              <el-tag
                :type="item.audit_status === 2 ? 'danger' : item.audit_status === 1 ? 'success' : 'warning'"
                size="small"
                disable-transitions
              >
                {{ item.audit_status_text }}
              </el-tag>
            </div>
          </el-col>
          <el-col :xl="6" :xs="6" :md="6" :lg="4" :sm="6">
            <div>
              发货状态：<el-tag v-if="item.audit_status === 1" size="small" disable-transitions>
                {{ item.status_text }}
                <span type="success" v-if="item.pick_up_order">[自提]</span>
              </el-tag>
            </div>
          </el-col>
          <el-col :xl="3" :xs="8" :md="8" :lg="5" :sm="8">
            <div>
              <span><i class="el-icon-pie-chart" />：</span>{{ item.pay_time }}
            </div>
          </el-col>
          <el-col :xl="1" :xs="4" :md="4" :lg="2" :sm="4">
            <div class="action">
              <el-dropdown>
                <el-button size="small">操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-view" v-if="hasPermsEdit">
                    <router-link :to="'/orders/' + item.id + '/edit'">
                      <el-button type="text" size="small">查看详情</el-button>
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-printer" v-if="item.audit_status === 1 && hasPermsPrint" divided>
                    <router-link :to="'/orders/' + item.id + '/print'">
                      <el-button type="text" size="small">打印清单</el-button>
                    </router-link>
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-guide" v-if="item.audit_status === 1 && hasPermsPrint" divided>
                    <el-button type="text" size="small" @click="onPrinterOrderConfirm(item)">打印小票</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-monitor" v-if="item.audit_status === 0" divided>
                    <el-button type="text" size="small">审核</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-guide" v-if="item.audit_status === 1 && hasPermsRefuse" divided>
                    <el-button type="text" size="small" @click="onRefuseOrderConfirm(item)">退单</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </div>
      </el-col>
      <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
        <div class="grid-content-col-body">
          <el-col :xl="8" :xs="24" :md="24" :lg="5" :sm="24">
            <div class="grid-body-left">
              <ul>
                <span>商品信息：</span>
                <li v-for="good in item.items" :key="good.id">
                  <!-- <img :src="good.thumbnail_pic"> -->
                  <!-- <span>{{ good.name }}*{{ good.price }}*{{ good.nums }}</span> -->
                  <el-image style="width: 25px; height: 25px" :src="good.thumbnail_pic" :preview-src-list="[good.thumbnail_pic]">
                    <div slot="error" class="image-slot"><i class="el-icon-picture-outline" /></div>
                  </el-image>
                  <span v-if="isLogistics"> {{ good.name }}*{{ good.nums }} </span>
                  <span v-else> {{ good.name }}*{{ good.price }}*{{ good.nums }} </span>
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :xl="16" :xs="18" :md="18" :lg="17" :sm="18">
            <div class="grid-body-right">
              <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content grid-body-right-content-first">
                  <el-col :xl="6" :xs="24" :md="24" :lg="6" :sm="24" v-if="!isLogistics">
                    <div class="grid-right-top">金额：{{ item.final_amount }}</div>
                  </el-col>
                  <el-col :xl="12" :xs="24" :md="24" :lg="12" :sm="24">
                    <div class="grid-right-top" v-if="isLogistics">账户信息：{{ item.user.real_name }}</div>
                    <div class="grid-right-top" v-else>
                      账户信息：{{ item.user.real_name }}({{ item.user.level_name }}) {{ item.user.mobile }}
                    </div>
                  </el-col>
                  <el-col :xl="6" :xs="24" :md="24" :lg="6" :sm="24">
                    <div class="grid-right-top grid-right-top-last">
                      物流信息：{{ item.belong_delivery_user_name }}
                      <el-button v-if="hasPermsExpress" @click="expressOrderInfo(item)" size="mini" type="text">查看物流</el-button>
                    </div>
                  </el-col>
                </div>
              </el-col>
              <!-- <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content">发货信息：{{ item.ship_area }}</div>
              </el-col> -->
              <!-- <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content grid-body-right-content-last">
                  收货信息：{{ item.ship_name }}({{ item.ship_mobile }}){{ item.ship_addr }}
                </div>
              </el-col> -->
            </div>
          </el-col>
        </div>
      </el-col>
    </el-row>

    <!-- <el-table :data="orders"
              resource="orders"
              v-loading="loading">
      <el-table-column prop="id"
                       label="标识"
                       width="80" />
      <el-table-column label="订单信息"
                       fixed
                       width="190">
        <template slot-scope="scope">
          <span>{{ scope.row.order_id }}</span>
          <br>
          <span>[{{ scope.row.order_type_text }}]</span>
          <br>
          <el-tag :type="scope.row.audit_status === 2 ? 'danger' : scope.row.audit_status === 1 ? 'success' : 'warning'"
                  size="small"
                  disable-transitions>
            {{ scope.row.audit_status_text }}
          </el-tag>
          <el-tag v-if="scope.row.audit_status === 1"
                  size="small"
                  disable-transitions>
            {{ scope.row.status_text }}
            <span type="success"
                  v-if="scope.row.pick_up_order">[自提]</span>
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center"
                       header-align="center"
                       label="账户信息"
                       width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span v-if="isLogistics">
              <span>{{ scope.row.user.real_name }}</span>
            </span>
            <span v-else>
              <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
              <br>
              <span>{{ scope.row.user.mobile }}</span>
              <br>
              <span>{{ scope.row.user.idcard_no }}</span>
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="商品信息"
                       width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.items">
            <div v-for="(item, index) in scope.row.items"
                 :key="index">
              <el-image style="width: 25px; height: 25px"
                        :src="item.thumbnail_pic"
                        :preview-src-list="[item.thumbnail_pic]">
                <div slot="error"
                     class="image-slot"><i class="el-icon-picture-outline" /></div>
              </el-image>
              <span v-if="isLogistics"> {{ item.name }}*{{ item.nums }} </span>
              <span v-else> {{ item.name }}*{{ item.price }}*{{ item.nums }} </span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="final_amount"
                       v-if="!isLogistics"
                       label="金额"
                       width="100" />

      <el-table-column label="收货信息"
                       width="250">
        <template slot-scope="scope">
          <span>{{ scope.row.ship_name }}({{ scope.row.ship_mobile }})</span>
          <br>
          <span>{{ scope.row.ship_addr }}</span>
        </template>
      </el-table-column>
      <el-table-column label="快递信息"
                       width="250">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.belong_delivery_user_name"
                  effect="plain"
                  size="small">{{ scope.row.belong_delivery_user_name }}</el-tag>
          <div v-if="scope.row.status !== 0">
            <span>{{ scope.row.express_company_name }}</span>
            <br>
            <span>{{ scope.row.express_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at"
                       label="下单时间"
                       width="170" />
      <el-table-column fixed="right"
                       label="操作"
                       width="100">
        <template slot-scope="scope">
          <el-dropdown>
            <el-button size="small">操作</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-view"
                                v-if="hasPermsEdit">
                <router-link :to="'/orders/' + scope.row.id + '/edit'">
                  <el-button type="text"
                             size="small">查看详情</el-button>
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-printer"
                                v-if="scope.row.audit_status === 1 && hasPermsPrint"
                                divided>
                <router-link :to="'/orders/' + scope.row.id + '/print'">
                  <el-button type="text"
                             size="small">打印清单</el-button>
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-monitor"
                                v-if="scope.row.audit_status === 0"
                                divided>
                <el-button type="text"
                           size="small">审核</el-button>
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-guide"
                                v-if="scope.row.audit_status === 1 && hasPermsRefuse"
                                divided>
                <el-button type="text"
                           size="small"
                           @click="onRefuseOrderConfirm(scope.row)">退单</el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table> -->

    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-drawer title="物流信息" :visible.sync="drawer">
      <el-form :inline="true" :model="expressOrder">
        <el-form-item label="物流公司" label-width="80px">
          {{ expressOrder.express_company_name || '' }}
        </el-form-item>
        <el-form-item label="快递单号" label-width="80px">
          {{ expressOrder.express_no || '' }}
        </el-form-item>
      </el-form>
      <div style="overflow-y:auto; height:65%;">
        <el-timeline>
          <el-timeline-item v-for="(express, index) in expressList" :key="index" :timestamp="express.time">
            {{ express.status }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import ButtonLink from '@c/ButtonLink'
import { getOrders, refuseOrder, exportOrder, expressOrder, printerOrder } from '@/api/orders'
import { getFirstError, can } from '@/libs/utils'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    ButtonLink,
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机/姓名',
        },
        {
          field: 'order_id',
          label: '订单号',
        },
        {
          field: 'title',
          label: '订单名称',
        },
        {
          field: 'order_type',
          label: '订单类型',
          type: 'el-select',
          options: [
            { id: 0, name: '普单订单' },
            { id: 1, name: '报单订单' },
            { id: 2, name: '积分订单' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'audit_status',
          label: '审核状态',
          type: 'el-select',
          options: [
            { id: 0, name: '待审核' },
            { id: 1, name: '审核成功' },
            { id: 2, name: '拒绝' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'status',
          label: '发货状态',
          type: 'el-select',
          options: [
            { id: 0, name: '待发货' },
            { id: 1, name: '发货中' },
            { id: 2, name: '已完成' },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker',
        },
      ],
      orders: [],
      page: null,
      query: {},
      loading: true,
      hasPermsEdit: false,
      hasPermsPrint: false,
      hasPermsRefuse: false,
      hasPermsExport: false,
      hasPermsExpress: false,
      hasPermsManageDownload: false,
      isLogistics: false,

      drawer: false,
      expressList: [],
      expressOrder: [],
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        await this.loadOrders()
      },
      immediate: true,
    },
  },
  methods: {
    async rsyncExport(option) {
      try {
        await exportOrder({ ...this.query, option })
        this.$message.success('离线下载中...')
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    async loadOrders() {
      this.loading = true
      const {
        data: { data, meta, isLogistics },
      } = await getOrders(this.query)
      this.orders = data
      this.page = meta
      this.isLogistics = isLogistics
      this.loading = false
    },
    async onRefuseOrderConfirm(row) {
      this.$confirm('确认要退单操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data } = await refuseOrder(row.order_id, {})
          this.loadOrders()
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async onPrinterOrderConfirm(row) {
      this.$confirm('确认要打印小票操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data } = await printerOrder(row.order_id, {})
          if (data.code == 200) {
            this.$message({
              type: 'success',
              message: '打印成功!',
            })
          } else {
            this.$message({
              type: 'error',
              message: data.msg,
            })
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    async expressOrderInfo(row) {
      console.log(row)

      const {
        data: { data },
      } = await expressOrder(row.order_id)

      const { express, order } = data

      this.expressList = express.list || []
      this.expressOrder = order || {}

      this.drawer = true
    },
  },
  created() {
    this.hasPermsEdit = can('orders.edit')
    this.hasPermsPrint = can('orders.print')
    this.hasPermsRefuse = can('orders.refuse')
    this.hasPermsExport = can('orders.export')
    this.hasPermsExpress = can('orders.express')
    this.hasPermsManageDownload = can('manage.download')
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  font-size: 14px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-el-row {
  border: 1px solid #d8d8d8;
}
.grid-content-col-title {
  min-height: 52px;
  line-height: 52px;
  padding: 0 10px;
  background-color: #f5f5f6;
  border-bottom: 1px solid #d8d8d8;
  color: #000;
  .action {
    text-align: right;
  }
}
.grid-content-col-body {
  min-height: 130px;
  color: #666;
  .grid-body-left {
    padding-bottom: 10px;
    ul {
      margin: 0;
      padding: 0;
      width: 100%;
      span {
        margin: 10px 0 0 10px;
        display: inline-block;
      }
      li {
        list-style: none;
        line-height: 26px;
        margin-left: 40px;
        span {
          margin-left: 10px;
        }
      }
    }
  }
  .grid-body-right {
    .grid-body-right-content {
      min-height: 52px;
      line-height: 52px;
      padding-left: 20px;
      .grid-right-top {
        padding-left: 20px;
      }
      .grid-right-top-fist {
        padding-left: 0;
      }
      .grid-right-top-last {
        border-right: 0;
      }
    }
    .grid-body-right-content-first {
      padding-left: 0;
    }
    .grid-body-right-content-last {
      border-bottom: 0;
    }
  }
}
</style>
